import i18n from 'i18next';
import Backend from 'i18next-http-backend';
import ICU from 'i18next-icu';
import { initReactI18next } from 'react-i18next';

const DEFAULT_LANGUAGE = 'pt-BR';
const SUPPORTED_LANGUAGES = ['pt-BR', 'en-US'] as const;
const LANGUAGE_STORAGE_KEY = 'cobli-language';

type SupportedLanguage = (typeof SUPPORTED_LANGUAGES)[number];
type DashboardWindow = Window & { __DASHBOARD_MONOREPO_VERSION__?: string };

const getInitialLanguage = () => {
  if (typeof window === 'undefined') return DEFAULT_LANGUAGE;
  try {
    const storedLanguage = window.localStorage.getItem(LANGUAGE_STORAGE_KEY) as SupportedLanguage | null;
    return storedLanguage && SUPPORTED_LANGUAGES.includes(storedLanguage) ? storedLanguage : DEFAULT_LANGUAGE;
  } catch {
    return DEFAULT_LANGUAGE;
  }
};

i18n
  .use(Backend)
  .use(initReactI18next)
  .use(ICU)
  .init({
    partialBundledLanguages: true,
    load: 'currentOnly',
    lng: getInitialLanguage(),
    supportedLngs: [...SUPPORTED_LANGUAGES],
    fallbackLng: DEFAULT_LANGUAGE,

    // backend
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json',
      queryStringParams: typeof window === 'undefined' ? undefined : { v: (window as DashboardWindow).__DASHBOARD_MONOREPO_VERSION__ },
    },
    react: {
      bindI18n: 'languageChanged loaded',
      nsMode: 'default',
      bindI18nStore: 'added removed',
    },
    debug: false,
    interpolation: {
      escapeValue: false, // React already escapes values
    },
    ns: [
      'common',
      'app-header',
      'login',
      'monitoring',
      'media',
      'drivers',
      'devices',
      'vehicles',
      'reports',
      'maintenance',
      'home',
      'account',
      'routing',
      'tracking',
      'safety',
      'checklists',
      'costs',
      'expenses',
      'fuel',
      'advanced-analytics',
      'ai',
      'business-manager',
      'crm',
      'device-configuration',
      'economic-driving',
      'expenses',
      'geofences',
      'global-search',
      'groups',
      'hooks',
      'livestream',
      'path-association',
      'proof-of-conclusion',
      'road-speed',
      'safety-dashboard',
      'safety-ranking',
      'fuel-card',
      'business-manager',
      'store',
      'training',
      'ui-business',
      'map',
      'integrations',
      'contract-renewal',
      'survey',
    ],
    keySeparator: '.',
    nsSeparator: ':',
    appendNamespaceToMissingKey: true,
    resources: {},
  });

export default i18n;
